import { writable } from 'easy-signal';

export const uidStore = writable<string>(null);
export const isAdminStore = writable<boolean>(false);
export const projectIdStore = writable<string>(null);
export const docIdStore = writable<string>('');
